module.exports = __webpack_public_path__ + "img/Rectangle 147@2x.d6cd3499.png";